module.exports = __webpack_public_path__ + "img/104.c1d956cb.jpg";